import React, {useState, useEffect, useCallback} from 'react';
// import _ from 'lodash';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import {withData} from '../../containers/DataContainer';
import NewUser from '../../components/Forms/NewUser';
import BackButton from '../../components/Buttons/BackButton';
import UsersTable from '../../components/Tables/Users';
import useStyles from '../styles';

import UserDetails from './Details';

const Users = ({
  data,
  fetchUsers,
  createUser,
  deleteUser
}) => {

  const classes = useStyles();

  const [path, setPath] = useState('root');
  const [isBusy, setBusy] = useState(true);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      await fetchUsers();
      setBusy(false);
    };
    fetchData();
  }, [fetchUsers, setBusy]);

  const _createUser = useCallback(async state => {
    setBusy(true);
    await createUser(state);
    setPath('root');
    setBusy(false);
  }, [createUser, setPath]);

  const _deleteUser = useCallback(() => {
    deleteUser({_id: modalData._id});
    setPath('root');
  }, [modalData, deleteUser, setPath]);

  const onRowClick = useCallback(async ({rowData}) => {
    setModalData(rowData);
    setPath('detail');
  }, [setPath, setModalData]);

  return <>
    <Paper className={classes.paper}>
      {path === 'new' || path === 'edit'
        ? <Grid container>
          <Grid item>
            <BackButton onClick={() => setPath('root')}/>
          </Grid>
          <NewUser submitForm={_createUser} update={path === 'edit'}/>
        </Grid>
        : <UsersTable
          toggleNewForm={() => setPath('new')}
          data={data.users}
          {...{isBusy, onRowClick}}
        />
      }
    </Paper>
    <UserDetails
      onDelete={_deleteUser}
      onClose={() => setPath('root')}
      isOpen={path === 'detail'}
      data={modalData}
    />
  </>;
};

export default withData(Users);
